import axios      from "app/services/axios/CustomAxios";
import { apiUrl } from "app/services/axios/configApi";

export function getToken() {
    return axios(`${apiUrl}/sanctum/csrf-cookie`);
}

export function login(email, password, remember = true) {
    return axios.post(`${apiUrl}/login`, {
        email   : email,
        password: password,
        remember: remember,
    });
}

export function logout() {
    return axios.post(`${apiUrl}/logout`).catch(error => error.response);
}

export function enableTwoFactorAuthentication() {
    return axios.post(`${apiUrl}/user/two-factor-authentication`);
}

export function confirmTwoFactorAuthentication(code) {
    return axios.post(`${apiUrl}/user/confirmed-two-factor-authentication`, {
        code: code.replaceAll(" ", ""),
    }).then(response => response.data);
}

export function twoFactorAuthenticationChallenge(code) {
    return axios.post(`${apiUrl}/two-factor-challenge`, {
        code: code.replaceAll(" ", ""),
    }).then(response => response.data);
}

export function getQrCode() {
    return axios(`${apiUrl}/user/two-factor-qr-code`).then(
        response => response.data
    );
}